var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90812 1.58381C9.34123 1.27219 8.65835 1.27219 8.09145 1.58381L2.80364 4.49049C2.18526 4.83042 1.7998 5.48834 1.7998 6.20393V11.7963C1.7998 12.5118 2.18526 13.1698 2.80364 13.5097L8.09145 16.4164C8.65835 16.728 9.34123 16.728 9.90812 16.4164L15.1959 13.5097C15.8143 13.1698 16.1998 12.5118 16.1998 11.7963V6.20393C16.1998 5.48834 15.8143 4.83042 15.1959 4.49049L9.90812 1.58381ZM8.45618 10.8518V11.9207H4.09463V6.16403H8.35178V7.23291H5.39038V8.48315H8.00572V9.51946H5.39038V10.8518H8.45618ZM14.154 11.9208L12.7459 11.9205L11.664 10.3156L11.661 10.3158C11.6415 10.3165 11.6229 10.3171 11.6033 10.3171H10.5532V9.25639H11.5314C11.9335 9.25639 12.234 9.1672 12.4327 8.98917C12.6307 8.81115 12.7304 8.57095 12.7304 8.25302C12.7304 7.93509 12.631 7.68823 12.4327 7.5128C12.2344 7.33737 11.9338 7.24964 11.5314 7.24964H10.5532V6.16411H11.6033C12.1072 6.16411 12.5418 6.24738 12.907 6.41504C13.2723 6.58234 13.5536 6.82179 13.7523 7.13454C13.951 7.44691 14.0499 7.82554 14.0499 8.25302C14.0499 8.68049 13.9506 9.04913 13.7523 9.35892C13.5536 9.6687 13.2718 9.90561 12.907 10.0703L12.9041 10.0716L12.9025 10.0723L12.901 10.0729L12.8986 10.0738L12.8958 10.0751L14.154 11.9208ZM8.82502 6.16411H10.0803V11.9208H8.82502V6.16411Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToken);
export default __webpack_public_path__ + "static/media/token.07893099f5e9626d8635127d716bafeb.svg";
export { ForwardRef as ReactComponent };